import UrunSayfasi from './urun/UrunSayfasi';

/**
 * YENİ ÜRÜN (`/stok/yeni`) — ürün kartıyla AYNI düzen, boş form.
 *
 * Kod tekildir; çakışırsa sunucu 409 döner ve hangi üründe kullanıldığını
 * söyler. `?kopya=<id>` ile açılırsa o ürünün alanları dolu gelir (kod ve
 * görseller hariç). Kaydedince ürün kartına geçilir; görseller orada eklenir.
 */
export default function YeniUrun() {
  return <UrunSayfasi id={null} />;
}
